import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render Special Recognition Award section for eligibility tab
 */
const SpecialRecognitionAwardSection = (): React.ReactElement => {
  return (
    <div
      className="rounded-bl-lg rounded-br-lg bg-gray-150"
      data-testid="special-recognition-award-section-component"
    >
      <AccordionV2
        testId="special-recognition-award"
        className="rounded-bl-lg rounded-br-lg border-x py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Special Recognition Award" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4">
          <p>
            Individuals and/or organisations that have demonstrated outstanding
            and exemplary corporate governance in the conduct of the affairs of
            their boards and organisations especially in the past year or more
            in an area not already covered by an existing SCA award.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default SpecialRecognitionAwardSection;
